import { useMutation } from 'react-query';
import marketingPublicationService from './marketingPublication.services';

export function useMarketingPublicationActive() {
  return useMutation(
    ['marketing-publication-active'],
    marketingPublicationService.getMarketingPublicationActive,
  );
}
